<template>
  <div class="container">
    <h1 class="title">Progress</h1>

    <div class="box">
      <div class="columns is-multiline">
        <div class="column is-one-third" v-for="t in types" :key="t">
          <progress-item :type="t"></progress-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Library from '@/library'
import ProgressItem from './ProgressItem.vue'

export default {
  name: 'DevelopmentProgress',

  computed: {
    types () {
      return Library.Enums.ObjectType
    }
  },

  components: {
    ProgressItem
  }
}
</script>
